import { render, staticRenderFns } from "./AttachFileComentarioFicha.vue?vue&type=template&id=8a34046e&scoped=true&"
import script from "./AttachFileComentarioFicha.vue?vue&type=script&lang=js&"
export * from "./AttachFileComentarioFicha.vue?vue&type=script&lang=js&"
import style0 from "./AttachFileComentarioFicha.vue?vue&type=style&index=0&id=8a34046e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a34046e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VCardActions } from 'vuetify/lib'
import { VChip } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
import { VDataTable } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VImg } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VProgressCircular } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
import { VTooltip } from 'vuetify/lib'
installComponents(component, {
  VBtn,
  VCard,
  VCardActions,
  VChip,
  VContainer,
  VDataTable,
  VFlex,
  VIcon,
  VImg,
  VLayout,
  VProgressCircular,
  VTextField,
  VTooltip,
})
